import { takeEvery, put } from 'redux-saga/effects';
import { onNewTasksFromImport, setWorkflowGridNeedsToRefresh, appNotify } from 'store/actions';

export function* checkWorkflowGridNeedsToRefreshSaga() {
    yield takeEvery(onNewTasksFromImport, function* ({ payload: newTaskChannel }) { // Fired by signalR when imports complete. Always show red dot for new imports
        try {
            yield put(setWorkflowGridNeedsToRefresh(true));
        } catch (error) {
            yield put(appNotify(error.message, 'error'));
        }
    });
}